"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadWirelessNetSystemNameRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const orcadModuleRef_1 = require("./orcadModuleRef");
class OrcadWirelessNetSystemNameRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, _hierarchy) {
        let owner;
        let legacyDanglingOwner;
        let connectionCount = 0;
        for (const [, nets] of group.getNets()) {
            for (const net of nets) {
                if (net.wires.length > 0) {
                    return undefined;
                }
                for (const connWithPos of net.connections) {
                    connectionCount++;
                    const dbId = (0, orcadModuleRef_1.placedPartDbIdFromModuleRef)(connWithPos.connection.moduleRef);
                    if (dbId === undefined) {
                        continue;
                    }
                    const pinNumber = connWithPos.connection.pinNumber ?? connWithPos.connection.pinRef;
                    if (legacyDanglingOwner === undefined || dbId < legacyDanglingOwner.dbId) {
                        legacyDanglingOwner = { dbId, pinNumber };
                    }
                    const pinPosition = connWithPos.connection.pinPosition;
                    if (pinPosition === undefined) {
                        continue;
                    }
                    if (owner === undefined || dbId < owner.dbId || (dbId === owner.dbId && pinPosition < owner.pinPosition)) {
                        owner = { dbId, pinPosition };
                    }
                }
            }
        }
        if (connectionCount === 1 && legacyDanglingOwner) {
            return `N${String(legacyDanglingOwner.dbId).padStart(5, '0')}${legacyDanglingOwner.pinNumber}`;
        }
        if (!owner) {
            return undefined;
        }
        return `N${String(owner.dbId).padStart(5, '0')}${owner.pinPosition}`;
    }
}
exports.OrcadWirelessNetSystemNameRule = OrcadWirelessNetSystemNameRule;
//# sourceMappingURL=OrcadWirelessNetSystemNameRule.js.map